import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { primitives } from '../../helpers/helpers'

const renderType = (enums, field) => {
	var types = <Link to={`/api/responses/${field.type}`}>{field.type}s</Link>
	// Renders arrays and collections + links, but only if they are response/request links.
	if (field.isArray) {
		if (primitives.includes(field.type)) {
			return <span>array of {field.type}s</span>
		} else if (enums[field.type]) {
			return <span>array of strings</span>
		} else {
			return <span>array of {types}</span>
		}
	} else if (field.isCollection) {
		if (primitives.includes(field.type)) {
			return <span>dictionary of {field.type}s</span>
		} else {
			return <span>dictionary of {types}</span>
		}
	}
	// Renders strings and the rest.
	if (field.isEnum) {
		return 'string'
	} else if (primitives.includes(field.type)) {
		return `${field.type}`
	} else {
		return <Link to={`/api/responses/${field.type}`}>{field.type}</Link>
	}
}

// Presentational Component
const DataType = ({ field, enums }) => {
	let type = renderType(enums, field)
	return <span className="type">{type}</span>
}

const mapStateToProps = (state, ownProps) => {
	return {
		enums: state.api.enums,
	}
}

DataType.propTypes = {
	field: PropTypes.object.isRequired,
	enums: PropTypes.object.isRequired,
}

export default connect(mapStateToProps)(DataType)



// WEBPACK FOOTER //
// ./src/components/api/DataType.js